import React, { FC } from 'react';

interface BannerTitleProps {
  text: string;
  text1: string;
}

export const BannerTitle: FC<BannerTitleProps> = ({
  text = '企業理念',
  text1 = 'CORPORATE PHILOSOPHY',
}) => {
  return (
    <div
      className={`bg-[100%_100%] h-[120px] relative 
        bg-[url('/assets/images/privacy/subtract-2.svg')]`}
    >
      <div
        className={`flex flex-col items-center gap-[4px] relative ${'top-[26px]'}`}
      >
        <div
          className="[font-family:var(--20-h2-font-family)] self-stretch mt-[-1.00px] 
          tracking-[var(--20-h2-letter-spacing)] text-[length:var(--20-h2-font-size)]
          text-[color:var(--neutralneutral-700)] font-[number:var(--20-h2-font-weight)]
          text-center leading-[var(--20-h2-line-height)] relative"
        >
          {text}
        </div>
        <div
          className="[font-family:var(--16-h3-uppercase-font-family)] 
          self-stretch tracking-[var(--16-h3-uppercase-letter-spacing)]
          text-[length:var(--16-h3-uppercase-font-size)] text-[color:var(--neutralneutral-700)]
          font-[number:var(--16-h3-uppercase-font-weight)] text-center
          leading-[var(--16-h3-uppercase-line-height)] relative"
        >
          {text1}
        </div>
      </div>
    </div>
  );
};
